import { InjectionToken } from '@angular/core';
import { AppNavigationDataAdapter } from './app-navigation-data-adapter.interface';

export const APP_NAVIGATION_DATA_ADAPTER = new InjectionToken<AppNavigationDataAdapter>('App Navigation Data Adapter');
